import { NgModule } from "@angular/core";
import { PessoasJuridicasPesquisaComponent } from "./pesquisa/pessoas-juridicas-pesquisa.component";
import { PessoasJuridicasListagemComponent } from "./pesquisa/listagem/pessoas-juridicas-listagem.component";
import { PessoasJuridicasRoutingModule } from "./pessoas-juridicas-routing.module";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";

@NgModule({
  declarations: [
    PessoasJuridicasPesquisaComponent,
    PessoasJuridicasListagemComponent,
  ],
  exports:[
    PessoasJuridicasPesquisaComponent,
    PessoasJuridicasListagemComponent,
  ],
  imports:[
    PessoasJuridicasRoutingModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule
  ],
  providers: [
    BnPipeCnpj
  ]
})
export class PessoasJuridicasModule{}
